import { useTranslation } from "react-i18next";
import { PaginatedData } from "../../../hooks/PaginationHooks";
import { TableHeaderWrapper } from "../../../components/common/Common.styles";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
import BorderRow from "../../../components/common/table/BorderRow";
import { AnalysisFile } from "../../../types/analysisFileTypes";

interface Props {
    paginatedData: PaginatedData<AnalysisFile>;
    showCompanyName: boolean;
}

export default function AnalysisFileTableHeader(props: Props) {
    const { t } = useTranslation();

    return (
        <TableHeaderWrapper>
            {
                props.showCompanyName &&
                <ServerSideTableColumnHeader
                    fieldName="companyName"
                    isSorted
                    label={t("tableColumnHeaders.companyName")}
                    firstCol
                    paginatedData={props.paginatedData}
                />
            }
            <ServerSideTableColumnHeader
                fieldName="creationTimestamp"
                firstCol={!props.showCompanyName}
                isSorted
                label={t("tableColumnHeaders.creationTimestamp")}
                paginatedData={props.paginatedData}
            />
            <ServerSideTableColumnHeader
                fieldName="fileType"
                isSorted
                label={t("tableColumnHeaders.fileType")}
                paginatedData={props.paginatedData}
            />
            <ServerSideTableColumnHeader
                fieldName="downloadUrl"
                isSorted={false}
                label={t("tableColumnHeaders.download")}
                paginatedData={props.paginatedData}
            />
            <BorderRow />
        </TableHeaderWrapper>
    );
};
